import { http } from "@/utils/axios";

/**
 * @msg: 获取准考证列表
 */
export function getExamCardList(params) {
    return http({
        url: http.baseUrl('zkolExamsSeat/getPage'),
        method: 'get',
        params
    })
}

/**
 * @msg: 查询线下考试设置
 */
export function getExamSet(params) {
    return http({
        url: http.baseUrl('zkolOfflineExamsSetting/getOfflineExamsSettingByBatchId'),
        method: 'get',
        params
    })
}

/**
 * @msg:修改线下考试
 */
export function saveOrUpdate(data) {
    return http({
        url: http.baseUrl('zkolOfflineExamsSetting/saveOrUpdate'),
        method: 'post',
        data,
        params: data
    })
}

/**
 * @msg: 导出准考证
 */
export function exportZkolExamsSeat(params) {
    return http({
        url: http.baseUrl('zkolExamsSeat/exportZkolExamsSeat'),
        method: 'get',
        params
    })
}

/**
 * @msg: 打印准考证
 */
export function downloadZIP(params) {
    return http({
        url: http.baseUrl('examinationCard/downloadZIP'),
        method: 'get',
        params
    })
}

/**
 * @msg: 打印准考证
 */
 export function getExamRoomsByBatchId(params) {
    return http({
        url: http.baseUrl('zkolOfflineExamsSetting/getExamRoomsByBatchId'),
        method: 'get',
        params
    })
}
